module.exports = __webpack_public_path__ + "static2024-7-11/img/send_gift.25460705.png";